export default {"src":"/_next/static/media/nas.f8ae29f5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};